import { AbilityBuilder, Ability } from '@casl/ability'

export const ability = new Ability(rulesForUser())

export function updateAbilityWithRole (user) {
  let role = ''
  if (user) {
    role = user.role
  }
  ability.update(rulesForUser(role))
  return ability
}

function rulesForUser (userRole) {
  return AbilityBuilder.define((allow, forbid) => {
    function baseRights () {
      allow('enterRoute', [
        'settings'
      ])
    }

    function agentRights () {
      baseRights()

      allow('enterRoute', [
        'contractCreate',
        'agentContracts',
        'contract',
        'subscriptionUpdate'
      ])

      allow('read', [
        'AllContractsOfAgent'
      ])
    }

    function agencyManagerRights () {
      baseRights()

      allow('enterRoute', [
        'agency',
        'agentOverview',
        'agencyOverview',
        'agencySettings',
        'agentSettings',
        'agencyAgents',
        'agencyContracts',
        'agencyStatements',

        'contractCreate',
        'contract',
        'subscriptionUpdate'
      ])

      allow('read', [
        'AllContractsOfAgency'
      ])
    }

    function administratorRights () {
      baseRights()

      allow('enterRoute', [
        'agencies',
        'users',
        'agencyOverview.admin',
        'agencySettings.admin',
        'agentOverview',
        'agentSettings'
      ])

      allow('read', [
        'AllAgencies',
        'AllAgents',
        'AllContractsOfAgencies',
        'AllContractsOfAgents'
      ])

      allow('edit', [
        'AllAgencies',
        'AllAgents'
      ])
    }

    switch (userRole) {
      case 'user':
        baseRights()
        break
      case 'agent':
        agentRights()
        break
      case 'agency_manager':
        agencyManagerRights()
        break
      case 'administrator':
        administratorRights()
        break
    }
  }).rules
}
